"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
exports.HeightAwareComponent = function (_a) {
    var active = _a.active, children = _a.children, setHeight = _a.setHeight, others = __rest(_a, ["active", "children", "setHeight"]);
    var measuredRef = react_1.useCallback(function (node) {
        if (node !== null) {
            setHeight(node.offsetHeight);
        }
        setTimeout(function () {
            if (node !== null) {
                setHeight(node.offsetHeight);
            }
        }, 30);
    }, [active]);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.cloneElement(react_1.default.Children.only(children), __assign(__assign({}, others), { ref: measuredRef }))));
};
